var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardAccountDetailsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.811,
    height: 11.108,
    viewBox: "0 0 14.811 11.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#757575;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.577,3H1.234A1.28,1.28,0,0,0,0,4.234v8.64a1.28,1.28,0,0,0,1.234,1.234H13.577a1.28,1.28,0,0,0,1.234-1.234V4.234A1.28,1.28,0,0,0,13.577,3m0,9.874H1.234V4.234H13.577v8.64M8.64,11.64v-.771c0-1.024-2.061-1.543-3.086-1.543s-3.086.518-3.086,1.543v.771H8.64M5.554,5.468A1.543,1.543,0,1,0,7.1,7.011,1.543,1.543,0,0,0,5.554,5.468m3.086,0v.617h3.7V5.468H8.64m0,1.234V7.32h3.7V6.7H8.64m0,1.234v.617h2.468V7.937H8.64",
    transform: "translate(0 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAccountDetailsOutline);
export default __webpack_public_path__ + "static/media/card-account-details-outline.b8b11f67083cd1a3cc38fc53d6904c2c.svg";
export { ForwardRef as ReactComponent };